import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class QuickfireBonusBubbleControl extends AbstractControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        if (V.API.BonusBubble.bubbleEnabled()) {
            const hitArea = layer.getSprite(assetName);

            hitArea.interactive = true;

            hitArea.on(ButtonEvent.POINTER_OVER.getPIXIEventString(), (event: PIXI.interaction.InteractionEvent) => this.onOver(event));
            hitArea.on(ButtonEvent.POINTER_OUT.getPIXIEventString(), () => this.onOut());
            hitArea.on(ButtonEvent.POINTER_UP_OUTSIDE.getPIXIEventString(), () => this.onOut());
        }
    }

    private onOver(event: PIXI.interaction.InteractionEvent) {
        const originalEvent = event.data.originalEvent;

        let x = 0;
        let y = 0;

        try {
            if (originalEvent instanceof TouchEvent) {
                x = originalEvent.touches[0].pageX;
                y = originalEvent.touches[0].pageY;
            }
        } catch (e) {
            // Edge doesn't support TouchEvent
        }

        if (originalEvent instanceof MouseEvent) {
            x = originalEvent.pageX;
            y = originalEvent.pageY;
        }

        V.API.BonusBubble.onBubbleTrigger(true, {x, y});
    }

    private onOut() {
        V.API.BonusBubble.onBubbleTrigger(false, null);
    }
}
